import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { MdOutlineRemoveRedEye } from 'react-icons/md'
import { useBotConfig } from '~/api'
import { Tooltip, TooltipContent, TooltipTrigger } from '~ui'

export const Route = createFileRoute('/educator/courses/$courseId')({
	component: EducatorLayout,
})

function EducatorLayout() {
	const botConfig = useBotConfig()
	const { courseId } = Route.useParams()
	return (
		<div className="flex min-h-screen flex-col">
			<header className="flex-shrink-0">
				<div className="bg-navy-100 flex shrink-0 items-center justify-between gap-x-[24px] gap-y-[8px] px-[32px] py-[8px] text-white lg:px-[80px]">
					<Link
						from="/educator/courses/$courseId"
						to="./apps"
						className="flex shrink-0 items-center gap-x-[12px] md:gap-x-[24px] lg:gap-x-[48px]"
					>
						<img
							alt="University of Melbourne"
							src="/logos/uom_logo.svg"
							className="hidden h-[48px] lg:block"
							aria-hidden="true"
						/>
						<img
							alt="University of Melbourne"
							src="/logos/uom_logo_vertical.svg"
							className="h-[48px] lg:hidden"
							aria-hidden="true"
						/>
						<img
							alt="Aila"
							src="/logos/aila_logo.svg"
							className="h-[26px] lg:block"
							aria-label="Aila logo"
						/>
					</Link>

					<div className="flex items-center">
						{botConfig != null && (
							<Tooltip>
								<TooltipTrigger className="bg-light-blue-25 text-navy-100 h-min w-full overflow-x-hidden rounded-[2px] px-[8px] py-[2px] text-[14px] font-[400] text-ellipsis whitespace-nowrap md:max-w-[380px]">
									{botConfig.tutor_bot_course_name}
								</TooltipTrigger>
								<TooltipContent
									side="bottom"
									className="bg-dark-blue-100 z-999 px-[8px] py-[4px] text-white"
								>
									{botConfig.tutor_bot_course_name}
								</TooltipContent>
							</Tooltip>
						)}
						<a
							href="https://q.surveys.unimelb.edu.au/jfe/form/SV_835DYg5YmbKAfGu"
							target="_blank"
							rel="noreferrer"
							className="hover:border-light-blue-100 hover:text-light-blue-100 active:border-light-blue-25! ml-[24px] hidden h-[32px] shrink-0 items-center border border-white px-[8px] py-[3px] text-[18px] md:flex"
						>
							Feedback
						</a>

						<div className="mx-[12px] hidden h-[32px] w-[1px] bg-white md:block"></div>

						<a
							target="_blank"
							href={`/student/courses/${courseId}`}
							className="hover:border-light-blue-100 hover:text-light-blue-100 active:border-light-blue-25! hidden h-[32px] shrink-0 items-center border border-white px-[8px] py-[3px] text-[18px] md:flex"
							rel="noreferrer"
						>
							<MdOutlineRemoveRedEye
								className="mr-[4px] h-[16px] shrink-0"
								aria-hidden="true"
							/>
							<span>Preview Aila</span>
						</a>
					</div>
				</div>
			</header>
			<div className="px-[32px] py-[24px] lg:px-[80px]">
				<Outlet />
			</div>
		</div>
	)
}
